var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6C6.59674 6 7.16903 5.76295 7.59099 5.34099C8.01295 4.91903 8.25 4.34674 8.25 3.75C8.25 3.15326 8.01295 2.58097 7.59099 2.15901C7.16903 1.73705 6.59674 1.5 6 1.5C5.40326 1.5 4.83097 1.73705 4.40901 2.15901C3.98705 2.58097 3.75 3.15326 3.75 3.75C3.75 4.34674 3.98705 4.91903 4.40901 5.34099C4.83097 5.76295 5.40326 6 6 6ZM7.5 3.75C7.5 4.14782 7.34196 4.52936 7.06066 4.81066C6.77936 5.09196 6.39782 5.25 6 5.25C5.60218 5.25 5.22064 5.09196 4.93934 4.81066C4.65804 4.52936 4.5 4.14782 4.5 3.75C4.5 3.35218 4.65804 2.97064 4.93934 2.68934C5.22064 2.40804 5.60218 2.25 6 2.25C6.39782 2.25 6.77936 2.40804 7.06066 2.68934C7.34196 2.97064 7.5 3.35218 7.5 3.75ZM10.5 9.75C10.5 10.5 9.75 10.5 9.75 10.5H2.25C2.25 10.5 1.5 10.5 1.5 9.75C1.5 9 2.25 6.75 6 6.75C9.75 6.75 10.5 9 10.5 9.75ZM9.75 9.747C9.74925 9.5625 9.6345 9.0075 9.126 8.499C8.637 8.01 7.71675 7.5 6 7.5C4.28325 7.5 3.363 8.01 2.874 8.499C2.3655 9.0075 2.2515 9.5625 2.25 9.747H9.75Z",
    fill: "#F24822"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardUser);
export default __webpack_public_path__ + "static/media/cardUser.0aebef1e0e68ff41651c97452c4597d5.svg";
export { ForwardRef as ReactComponent };